import { useState, useEffect } from "react";
import { getContracts } from "../actions";

const useContracts = () => {
  const [contracts, setContracts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchContracts() {
      setLoading(true);
      setError(null);
      try {
        const response = await getContracts()
        setContracts(response);
      } catch (err) {
        setError(err?.message || "Erro desconhecido");
      } finally {
        setLoading(false);
      }
    }

    fetchContracts();
  }, []);

  return { contracts, loading, error };
};

export default useContracts;
